'use client';

import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import Script from 'next/script';

type StoryblokBridgeInstance = {
  on: (events: string[], callback: () => void) => void;
};

type StoryblokBridgeConstructor = new (options?: {
  preventClicks?: boolean;
}) => StoryblokBridgeInstance;

export function StoryblokPreviewBridge() {
  const router = useRouter();

  const registerBridge = useCallback(() => {
    const StoryblokBridge = (
      window as typeof window & { StoryblokBridge?: StoryblokBridgeConstructor }
    ).StoryblokBridge;

    if (!StoryblokBridge) {
      return;
    }

    const bridge = new StoryblokBridge({ preventClicks: true });
    bridge.on(['change', 'published'], () => router.refresh());
  }, [router]);

  return (
    <Script
      id="storyblok-preview-bridge"
      onLoad={registerBridge}
      src="https://app.storyblok.com/f/storyblok-v2-latest.js"
      strategy="afterInteractive"
    />
  );
}
